module.exports = __webpack_public_path__ + "static/media/heroGif.435f0074.gif";